// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__131I8","errors":"Errors_errors__1VYIO"};